/** Подпись кнопки выбора файлов для ссылок в письме (числительные по-русски). */
export function getEmailAttachFilesButtonLabel(selectedCount: number): string {
  if (selectedCount <= 0) return 'Прикрепить файлы';
  const n = selectedCount;
  const mod10 = n % 10;
  const mod100 = n % 100;
  let word: string;
  if (mod10 === 1 && mod100 !== 11) word = 'файл';
  else if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) word = 'файла';
  else word = 'файлов';
  if (n === 1) return `Прикреплён 1 ${word}`;
  return `Прикреплено ${n} ${word}`;
}

/** Подпись кнопки черновика заметок в модалке создания проекта (числительные по-русски). */
export function getAddProjectDraftNotesButtonLabel(nonEmptyCount: number): string {
  if (nonEmptyCount <= 0) return 'Добавить заметки';
  const n = nonEmptyCount;
  const mod10 = n % 10;
  const mod100 = n % 100;
  let word: string;
  if (mod10 === 1 && mod100 !== 11) word = 'заметка';
  else if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) word = 'заметки';
  else word = 'заметок';
  if (n === 1) return `Добавлена 1 ${word}`;
  return `Добавлено ${n} ${word}`;
}
